<template>
  <loader v-if="isLoader" />
  <div class="container-fluid" v-if="!isLoader">
    <!-- Header and Chart Row -->
    <div class="row">
      <!-- Header -->
      <div class="col-12 header">
        <div class="row">
          <div class="col-lg-3 logo-container">
            <a href="/#/" v-if="false">
              <img
                src="@/assets/images/logo-lg-light.svg"
                alt="#"
                v-if="theme == 'light'"
              />
            </a>

            <a href="/#/" v-if="false">
              <img
                src="@/assets/images/logo-lg-medium.svg"
                alt="#"
                v-if="theme == 'medium'"
              />
            </a>

            <a href="/#/" v-if="false">
              <img
                src="@/assets/images/logo-lg-dark.svg"
                alt="#"
                v-if="theme == 'dark'"
              />
            </a>
          </div>
          <div class="col-lg-6 dash-heading-container">
            <h1 v-if="lang == 'ar'">لوحة أداء القطاع</h1>
            <h1 v-if="lang == 'en'">Sector Dashboard</h1>
            <div class="line"></div>
          </div>
          <div class="col-lg-3 custom-dropdown-container">
            <div class="arrowlogo">
              <img
                src="@/assets/images/arrow-h-dark.png"
                alt="#"
                v-if="theme == 'dark'"
              />
              <img
                src="@/assets/images/arrow-h-medium.png"
                alt="#"
                v-if="theme == 'medium'"
              />
              <img
                src="@/assets/images/arrow-h-light.png"
                alt="#"
                v-if="theme == 'light'"
              />
            </div>
            <div class="togglers">
              <lang-toggler-v3></lang-toggler-v3>
              <theme-toggler-v3></theme-toggler-v3>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Toggle -->
      <div
        :class="
          tabToggleFilter == 'حسب الخطة'
            ? 'col-12 tab-toggles onplanned'
            : tabToggleFilter == 'تم الاطلاق(مكتمل)'
            ? 'col-12 tab-toggles completed'
            : tabToggleFilter == 'متوقع التأخير/ملاحظة مهمة'
            ? 'col-12 tab-toggles expectedlate'
            : 'col-12 tab-toggles late'
        "
      >
        <!-- Absolute Home Icon -->
        <div class="homeicon" @click="navigate('/sectors')">
          <img src="@/assets/images/icons/homeicon.svg" alt="#" />
        </div>
        <div
          :class="
            tabToggleFilter == 'تم الاطلاق(مكتمل)'
              ? 'toggle completed active'
              : 'toggle completed'
          "
          @click="switchTabToggle('تم الاطلاق(مكتمل)')"
        >
          <h1 class="count">{{ sectorHealth.completed }}</h1>
          <h2 class="title">
            المشاریع<br />
            تم الاطلاق(مكتمل)
          </h2>
          <img src="@/assets/images/icons/onplanned-sectordetail.svg" alt="#" />
        </div>
        <div
          :class="
            tabToggleFilter == 'حسب المخطط'
              ? 'toggle onplanned active'
              : 'toggle onplanned'
          "
          @click="switchTabToggle('حسب المخطط')"
        >
          <h1 class="count">{{ sectorHealth.onplanned }}</h1>
          <h2 class="title">
            المشاریع<br />
            حسب الخطة
          </h2>
          <img src="@/assets/images/icons/onplanned-sectordetail.svg" alt="#" />
        </div>
        <div
          :class="
            tabToggleFilter == 'متوقع التأخير/ملاحظة مهمة'
              ? 'toggle expectedlate active'
              : 'toggle expectedlate'
          "
          @click="switchTabToggle('متوقع التأخير/ملاحظة مهمة')"
        >
          <h1 class="count">{{ sectorHealth.expectedlate }}</h1>
          <h2 class="title">
            المشاریع<br />
            متوقع التأخير
          </h2>
          <img src="@/assets/images/icons/onplanned-sectordetail.svg" alt="#" />
        </div>
        <div
          :class="
            tabToggleFilter == 'متأخر' ? 'toggle late active' : 'toggle late'
          "
          @click="switchTabToggle('متأخر')"
        >
          <h1 class="count">{{ sectorHealth.late }}</h1>
          <h2 class="title">
            المشاریع<br />
            متأخر
          </h2>
          <img src="@/assets/images/icons/onplanned-sectordetail.svg" alt="#" />
        </div>
      </div>

      <!-- Tiles Section -->
      <div class="col-12 chart-container">
        <div class="chart-tile">
          <h2 class="floating-number">
            {{
              sectorData.projects.filter((item) => item.ProjectType == "داخلي")
                .length
            }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-briefcase.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">المشاریع الداخلیة</span>
            <span v-if="lang == 'en'">Internal Projects</span>
          </div>
          <circular-pie-v3
            id="cirpie1"
            :data="this.sectorData.internalProjects"
            v-if="this.sectorData.internalProjects.isData"
          ></circular-pie-v3>
        </div>
        <div class="chart-tile">
          <h2 class="floating-number">
            {{
              sectorData.projects.filter((item) => item.ProjectType == "خارجي")
                .length
            }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-rocket.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">المشاریع الخارجیة</span>
            <span v-if="lang == 'en'">External Projects</span>
          </div>
          <circular-pie-v3
            id="cirpie2"
            :data="this.sectorData.externalProjects"
            v-if="this.sectorData.externalProjects.isData"
          ></circular-pie-v3>
        </div>
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number">{{ sectorData.catEfada.totalEfada }}</h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-folder.svg"
              alt="#"
              class="tilehead-icon"
            />
            <span v-if="lang == 'ar'">تصنیف المشاریع</span>
            <span v-if="lang == 'en'">Project Classification</span>
          </div>
          <pie-v3
            id="pie2"
            :chartData="this.sectorData.catEfada.labels"
            :chartColors="this.sectorData.catEfada.colors"
            v-if="this.sectorData.catEfada.isData"
          />
        </div>
      </div>
    </div>

    <!-- Budget Explanation -->
    <div class="row">
      <div class="col-12 budget-records">
        <h1>التفاصیل المالیة</h1>
        <div class="budget-tile-container">
          <div class="budget-tile">
            <div class="icon">
              <img src="@/assets/images/icons/approved-budget.svg" alt="#" />
            </div>
            <h3>المیزانیة المعتمدة (ر.س)</h3>
            <h4>{{ this.sectorData.budgets.approvedBudget }}</h4>
          </div>
          <div class="budget-tile">
            <div class="icon">
              <img
                src="@/assets/images/icons/contract-value-budget.svg"
                alt="#"
              />
            </div>
            <h3>ﻗﯿﻤﺔ اﻟﻌﻘﺪ (ر.س)</h3>
            <h4>{{ this.sectorData.budgets.contractValue }}</h4>
          </div>
          <div class="budget-tile">
            <div class="icon">
              <img src="@/assets/images/icons/balance-budget.svg" alt="#" />
            </div>
            <h3>اﻟﻤﯿﺰاﻧﯿﺔ اﻟﻤﺘﺎﺣﺔ اﻟﻤﺘﺒﻘﯿﺔ (ر.س)</h3>
            <h4>{{ this.sectorData.budgets.balance }}</h4>
          </div>
          <div class="budget-tile">
            <div class="icon">
              <img src="@/assets/images/icons/currentyear-budget.svg" alt="#" />
            </div>
            <h3>اﻟﻌﺎم اﻟﺤﺎﻟﻲ</h3>
            <h4>{{ this.sectorData.budgets.currentYear }}</h4>
          </div>
          <div class="budget-tile">
            <div class="icon">
              <img src="@/assets/images/icons/count-budget.svg" alt="#" />
            </div>
            <h3>المخاطر</h3>
            <h4>{{ this.sectorData.budgets.count }}</h4>
          </div>
          <div class="budget-tile">
            <div class="icon">
              <img src="@/assets/images/icons/actualspent-budget.svg" alt="#" />
            </div>
            <h3>اﻟﻤﺪﻓﻮع ﻟﻠﺴﻨﺔ اﻟﺤﺎﻟﯿﺔ (ر.س)</h3>
            <h4>{{ this.sectorData.budgets.actualSpent }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress and Filter Charts -->
    <div class="row">
      <div class="col-12 chart-container">
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number" v-if="false">22</h2>
          <div class="tilehead" style="margin-bottom: 20px">
            <img
              src="@/assets/images/icons/v3-notes.svg"
              alt="#"
              class="tilehead-icon"
            />

            <span v-if="lang == 'ar'">الميزانية</span>
            <span v-if="lang == 'en'">Budget</span>
          </div>
          <circular-progress-v3
            id="cirp-1"
            :per="sectorData.progressChart.allPercentageValue"
            name="اجمالي العقود"
          />
          <div class="chart-desc-container">
            <div class="chart-desc">
              <!-- <img src="@/assets/images/icons/chartup.svg" alt="#" /> -->
              <h5>قيمة العقد</h5>
              <h6>{{ numeralFormatter(sectorData.contractValue) }}</h6>
            </div>
            <div class="chart-desc">
              <!-- <img src="@/assets/images/icons/chartdown.svg" alt="#" /> -->
              <h5>قیمة المدفوع</h5>
              <h6>{{ numeralFormatter(sectorData.actualSpent) }}</h6>
            </div>
          </div>
        </div>
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number">
            {{ sectorData.contractStatus.totalContracts }}
          </h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-folder.svg"
              alt="#"
              class="tilehead-icon"
            />
            <span v-if="lang == 'ar'">تصنیف المشاریع</span>
            <span v-if="lang == 'en'">Project Classification</span>
          </div>
          <pie-v3
            id="pie1"
            :chartData="this.sectorData.contractStatus.labels"
            :chartColors="this.sectorData.contractStatus.colors"
            v-if="this.sectorData.contractStatus.isData"
          />
        </div>
        <div class="chart-tile" style="justify-content: flex-start">
          <h2 class="floating-number">{{ sectorData.projects.length }}</h2>
          <div class="tilehead">
            <img
              src="@/assets/images/icons/v3-comment.svg"
              alt="#"
              class="tilehead-icon"
            />
            <span v-if="lang == 'ar'">حالة المشاریع</span>
            <span v-if="lang == 'en'">Project Status</span>
          </div>
          <circular-pie-filter-v3
            id="cirpie4"
            :pieChartData="sectorData.pieChart"
            v-if="sectorData.pieChart.isData"
          />
        </div>
      </div>
    </div>

    <!-- Data based on Tiles Fitlers -->
    <div class="row" id="databased-row">
      <div class="col-12 filter-based-data">
        <h1 v-if="lang == 'ar'">لوحة أداء المشاریع الإستراتیجیة</h1>
        <h1 v-if="lang == 'en'">Strategic projects Dashboard</h1>
      </div>
      <div class="col-12 tab-data">
        <div
          :class="activeFilters.health == 'all' ? 'tabs active all' : 'tabs'"
          @click="filterProjects('all')"
        >
          <h1 v-if="lang == 'ar'">الكل</h1>
          <h1 v-if="lang == 'en'">All</h1>
          <div class="mark all">
            {{ sectorData.projects.length }}
          </div>
        </div>
        <div
          :class="
            activeFilters.health == 'تم الاطلاق(مكتمل)'
              ? 'tabs active completed'
              : 'tabs'
          "
          @click="filterProjects('تم الاطلاق(مكتمل)')"
        >
          <h1 v-if="lang == 'ar'">ﺗﻢ اﻟﺎﻃﻠﺎق)ﻣﻜﺘﻤﻞ)</h1>
          <h1 v-if="lang == 'en'">Completed</h1>
          <div class="mark completed">
            {{
              sectorData.projects.filter(
                (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
              ).length
            }}
          </div>
        </div>
        <div
          :class="
            activeFilters.health == 'حسب المخطط'
              ? 'tabs active onplanned'
              : 'tabs'
          "
          @click="filterProjects('حسب المخطط')"
        >
          <h1 v-if="lang == 'ar'">حسب المخطط</h1>
          <h1 v-if="lang == 'en'">As Planned</h1>
          <div class="mark onplanned">
            {{
              sectorData.projects.filter(
                (item) => item.ProjectStatus == "حسب المخطط"
              ).length
            }}
          </div>
        </div>
        <div
          :class="
            activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'
              ? 'tabs active expectedlate'
              : 'tabs'
          "
          @click="filterProjects('متوقع التأخير/ملاحظة مهمة')"
        >
          <h1 v-if="lang == 'ar'">متوقع التأخير</h1>
          <h1 v-if="lang == 'en'">Expected Late</h1>
          <div class="mark expectedlate">
            {{
              sectorData.projects.filter(
                (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
              ).length
            }}
          </div>
        </div>
        <div
          :class="activeFilters.health == 'متأخر' ? 'tabs active late' : 'tabs'"
          @click="filterProjects('متأخر')"
        >
          <h1 v-if="lang == 'ar'">متأخر</h1>
          <h1 v-if="lang == 'en'">Late</h1>
          <div class="mark late">
            {{
              sectorData.projects.filter(
                (item) => item.ProjectStatus == "متأخر"
              ).length
            }}
          </div>
        </div>

        <div
          :class="
            activeFilters.health == 'ملغي' ? 'tabs active archived' : 'tabs'
          "
          @click="filterProjects('ملغي')"
        >
          <h1 v-if="lang == 'ar'">ملغي</h1>
          <h1 v-if="lang == 'en'">Archived</h1>
          <div class="mark archived">
            {{
              sectorData.projects.filter((item) => item.ProjectStatus == "ملغي")
                .length
            }}
          </div>
        </div>
      </div>

      <div class="col-12 markline-container">
        <img
          src="@/assets/images/line-all.svg"
          alt="#"
          v-if="activeFilters.health == 'all'"
        />
        <!-- <img src="@/assets/images/line-dark.svg" alt="#" v-if="activeTab =='all' && theme =='dark'"> -->
        <img
          src="@/assets/images/line-late.svg"
          alt="#"
          v-if="activeFilters.health == 'متأخر'"
        />
        <img
          src="@/assets/images/line-onplanned.svg"
          alt="#"
          v-if="activeFilters.health == 'حسب المخطط'"
        />
        <img
          src="@/assets/images/line-completed.svg"
          alt="#"
          v-if="activeFilters.health == 'تم الاطلاق(مكتمل)'"
        />
        <img
          src="@/assets/images/line-expectedlate.svg"
          alt="#"
          v-if="activeFilters.health == 'متوقع التأخير/ملاحظة مهمة'"
        />
      </div>
      <div class="col-12 tile-table">
        <div class="custom-filter">
          <div
            :class="sectorData.tableView ? 'togg table active' : 'togg table'"
            @click="changeProjectView('table')"
          >
            <img src="@/assets/images/icons/v3-table-view.svg" alt="#" />
          </div>
          <div
            :class="sectorData.tileView ? 'togg tile active' : 'togg tile'"
            @click="changeProjectView('tile')"
          >
            <img src="@/assets/images/icons/v3-tile-view.svg" alt="#" />
          </div>
        </div>

        <search-filter v-if="false" />
      </div>

      <div class="panel-wrapper">
        <template
          v-for="(item, index) in Object.values(activeFilters)"
          :key="item"
        >
          <div class="current-filters" v-if="item != '' && item != 'all'">
            <span class="active-filter">{{ item }}</span>
            <img
              src="@/assets/images/icons/close-filter.svg"
              alt="#"
              v-if="theme == 'dark' || theme == 'medium'"
              @click="makeActiveFilterNone(index)"
            />
            <img
              src="@/assets/images/icons/close-filter-light.svg"
              alt="#"
              v-if="theme == 'light'"
              @click="makeActiveFilterNone(index)"
            />
          </div>
        </template>
      </div>

      <!-- Added filter panel -->
      <div class="col-12 filter-panel">
        <div class="dropdown-filter" @click="openProjectClassification">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project Classification</span>
          <span v-if="lang == 'ar'">تصنيف المشاريع</span>

          <div class="filter-dropdown" v-if="isProjectClassification">
            <ul>
              <li
                @click="filterProjectsByClassification(label.key)"
                v-for="label in sectorData.catEfada.labels"
                :key="label.key"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openRFP">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">RFP Status</span>
          <span v-if="lang == 'ar'">كراسات الطرح</span>

          <div class="filter-dropdown" v-if="isProjectRFP">
            <ul>
              <li
                @click="filterProjectsByRFP(label.key)"
                v-for="label in sectorData.contractStatus.labels"
                :key="label.key"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openProjectSector">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project By Sector</span>
          <span v-if="lang == 'ar'">مشاريع حسب القطاع</span>

          <div class="filter-dropdown" v-if="isProjectSector">
            <ul>
              <li
                @click="filterProjectsBySector(label.key)"
                v-for="label in sectorData.projectSector.labels"
                :key="label"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openProjectType">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project Type</span>
          <span v-if="lang == 'ar'">نوع المشروع</span>

          <div class="filter-dropdown" v-if="isProjectType">
            <ul>
              <li @click="filterProjectsByProjectType('داخلي')">
                داخلي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('خارجي')">
                خارجي
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByProjectType('طلب التغيير')">
                طلب التغيير
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-filter" @click="openInternalProjects">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Project Phase</span>
          <span v-if="lang == 'ar'">المرحلة</span>

          <div class="filter-dropdown" v-if="isInternalProject">
            <ul>
              <li @click="filterProjectsByInternal('التنفيذ')">
                التنفيذ
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('الإغلاق')">
                الإغلاق
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('البدء')">
                البدء
                <span v-if="false">0</span>
              </li>
              <li @click="filterProjectsByInternal('التخطيط')">
                التخطيط
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openMiscFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Select Filter</span>
          <span v-if="lang == 'ar'">أختر</span>

          <div class="filter-dropdown" v-if="isMiscFilter">
            <ul>
              <li @click="filterProjectsByMisc('مبادرات مجلس الإدارة')">
                مبادرات مجلس الإدارة
              </li>
              <li style="cursor: default; font-weight: 800 !important">
                متوائمة
              </li>
              <li @click="filterProjectsByMisc('مشاريع السنة الحالي')">
                مشاريع السنة 2022
                <span v-if="false">{{
                  projects.filter((item) => {
                    let date = new Date(item.ProjectFinishDate);
                    if (
                      date.getFullYear() == new Date().getFullYear() &&
                      item.IsAligned == "نعم"
                    ) {
                      return item;
                    }
                  }).length
                }}</span>
              </li>
              <li @click="filterProjectsByMisc('مشاريع السنة القادم')">
                مشاريع السنة 2023
                <span v-if="false">{{
                  projects.filter((item) => {
                    let date = new Date(item.ProjectFinishDate);
                    if (
                      date.getFullYear() == new Date().getFullYear() + 1 &&
                      item.IsAligned == "نعم"
                    ) {
                      return item;
                    }
                  }).length
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openTierFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Select Filter</span>
          <span v-if="lang == 'ar'">أختر</span>

          <div class="filter-dropdown" v-if="isTierVisible">
            <ul>
              <!--  <li @click="filterProjectsByTier('Special Tier (1)')">
                Special Tier (1)
                <span>{{ projects.filter(item => item.Priority == 'Special Tier (1)').length }}</span>

              </li>-->
              <li @click="filterProjectsByTier('Tier (1)')">
                Tier (1)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (1)").length
                }}</span>
              </li>
              <li @click="filterProjectsByTier('Tier (2)')">
                Tier (2)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (2)").length
                }}</span>
              </li>
              <li @click="filterProjectsByTier('Tier (3)')">
                Tier (3)
                <span v-if="false">{{
                  projects.filter((item) => item.Priority == "Tier (3)").length
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openAlignmentFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">هل المشروع متوائم؟</span>
          <span v-if="lang == 'ar'">هل المشروع متوائم؟</span>

          <div class="filter-dropdown" v-if="isProjectAlignment">
            <ul>
              <li @click="filterProjectsByAlignment('نعم')">
                متوائم
                <span v-if="false">{{
                  projects.filter((item) => item.IsAligned == "نعم").length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('التواريخ')">
                غير متوائم(التواريخ)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" && item.NotAligned == "التواريخ"
                  ).length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('النطاق')">
                غير متوائم(النطاق)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" && item.NotAligned == "النطاق"
                  ).length
                }}</span>
              </li>
              <li @click="filterProjectsByAlignment('التواريخ و النطاق')">
                غير متوائم(الكل)
                <span v-if="false">{{
                  projects.filter(
                    (item) =>
                      item.IsAligned == "لا" &&
                      item.NotAligned == "التواريخ و النطاق"
                  ).length
                }}</span>
              </li>
              <!--   <li @click="filterProjectsByAlignment('لا ينطبق')">
                لا ينطبق
                <span>{{ projects.filter(item => item.IsAligned == 'لا ينطبق').length }}</span>
                
              </li>-->
              <li @click="filterProjectsByAlignment('TBD')">
                TBD
                <span v-if="false">{{
                  projects.filter((item) => item.IsAligned == "TBD").length
                }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="dropdown-filter" @click="openDepartmentFilter">
          <img
            src="@/assets/images/icons/v3-angledown.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'light' || theme == 'medium'"
          />
          <img
            src="@/assets/images/icons/angle-down-td.svg"
            alt="#"
            class="angledown"
            v-if="theme == 'dark'"
          />
          <span v-if="lang == 'en'">Department Filter</span>
          <span v-if="lang == 'ar'">الجهة المالكة</span>

          <div class="filter-dropdown" v-if="isProjectDepartment">
            <ul>
              <li
                @click="filterProjectsByDepartment(label.key)"
                v-for="label in sectorData.department.labels"
                :key="label.key"
                :title="label.key"
              >
                {{ label.key }}
                <span v-if="false">0</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="cf-project-count" v-if="filteredProjects">
        <h1>
          عدد المشاريع
          <span>{{ `( ${filteredProjects.length} )` }}</span>
        </h1>
      </div>

      <div class="col-12" v-if="sectorData.tileView">
        <project-loader v-if="isProjectLoader" />
        <div class="row" v-if="!isProjectLoader">
          <div
            class="col-4 filter-data-tile"
            v-for="(project, index) in filteredProjects"
            :key="project.index"
          >
            <a :href="`/#/project-ar?id=${project.ProjectUID}`" target="_blank">
              <div class="tilehead trimed-title">
                <!-- new code added -->
                <template
                  v-for="milestone in sectorData.milestones"
                  :key="milestone.TaskUID"
                >
                  <div
                    class="task-check"
                    v-if="milestone.ProjectUID == project.ProjectUID"
                  >
                    <img src="@/assets/images/icons/green.svg" alt="#" />
                  </div>
                </template>
                <!--ends-->
                <h1 v-if="lang == 'ar'">
                  {{ project.ProjectName }}
                </h1>
                <h1 v-if="lang == 'en'">{{ project.ProjectName }}</h1>

                <h2 v-if="lang == 'ar' && project.ProjectStatus == 'متأخر'">
                  <span class="late">متأخر</span>
                </h2>
                <h2 v-if="lang == 'en' && project.ProjectStatus == 'متأخر'">
                  <span class="late">Late</span>
                </h2>

                <h2 v-if="lang == 'ar' && project.ProjectStatus == 'ملغي'">
                  <span class="archived">ملغي</span>
                </h2>
                <h2 v-if="lang == 'en' && project.ProjectStatus == 'ملغي'">
                  <span class="archived">Archived</span>
                </h2>

                <h2
                  v-if="lang == 'ar' && project.ProjectStatus == 'حسب المخطط'"
                >
                  <span class="onplanned">ﺣﺴﺐ اﻟﻤﺨﻄﻂ</span>
                </h2>
                <h2
                  v-if="lang == 'en' && project.ProjectStatus == 'حسب المخطط'"
                >
                  <span class="onplanned">As Planned</span>
                </h2>

                <h2
                  v-if="
                    lang == 'ar' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                  "
                >
                  <span class="completed">تم الاطلاق(مكتمل)</span>
                </h2>
                <h2
                  v-if="
                    lang == 'en' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                  "
                >
                  <span class="completed">Completed</span>
                </h2>
                <h2
                  v-if="
                    lang == 'ar' &&
                    project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                  "
                >
                  <span class="expectedlate">متوقع التأخير</span>
                </h2>
                <h2
                  v-if="
                    lang == 'en' &&
                    project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                  "
                >
                  <span class="expectedlate">Expected Late</span>
                </h2>
                <h3 class="sector-status">
                  (

                  {{ project.ProjectPhase }}

                  )
                </h3>

                <div class="project-progress-date">
                  <div class="pinfo">
                    <span>{{ getOnlyDate(project.ProjectStartDate) }}</span>
                    <span>{{ getOnlyDate(project.ProjectFinishDate) }}</span>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      :style="`width: ${calculateProjectDateProgress(
                        project.ProjectStartDate,
                        project.ProjectFinishDate
                      )}%`"
                    >
                      <template
                        v-for="(milestone, i) in sectorData.milestones"
                        :key="milestone.TaskUID"
                      >
                        <span style="display: none">{{
                          i > 6 ? (i = 1) : ""
                        }}</span>
                        <div
                          :style="`left:${i * 15 + 5}%!important`"
                          :class="`diamond ${
                            milestone.TaskStatus == 'متأخر'
                              ? 'late'
                              : milestone.TaskStatus == 'حسب المخطط'
                              ? 'onplanned'
                              : milestone.TaskStatus == 'مكتمل'
                              ? 'completed'
                              : milestone.TaskStatus ==
                                'متوقع التأخير/ملاحظة مهمة'
                              ? 'expectedlate'
                              : 'onplanned'
                          }`"
                          :title="`${milestone.TaskName}`"
                          v-if="
                            milestone.ProjectUID == project.ProjectUID && i < 6
                          "
                        ></div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-6 round-chart">
                    <h1 v-if="lang == 'ar'">نسبة الأنجاز</h1>
                    <h1 v-if="lang == 'en'">Progress</h1>
                    <div class="col-12 ch halfcut1">
                      <halfcut-progress-lite
                        :baseContainer="`first-progress-${index}`"
                        :valueContainer="`first-value-container-${index}`"
                        color="#48B0C4"
                        :data="project.ActualCompletePercent"
                      />
                      <half-cut-progress-v3
                        v-if="false"
                        :id="`halfcut${index}`"
                        color="#48B0C4"
                        :data="project.ActualCompletePercent"
                        title="الأنجاز"
                      />
                    </div>
                    <h2 v-if="lang == 'ar'">
                      المخطط
                      <b>%{{ project.PlannedCompletePercent }}</b>
                    </h2>
                    <h2 v-if="lang == 'en'">
                      Planned
                      <b>{{ project.PlannedCompletePercent }}%</b>
                    </h2>
                    <h2 v-if="lang == 'ar'">
                      الفعلي
                      <b>%{{ project.ActualCompletePercent }}</b>
                    </h2>
                    <h2 v-if="lang == 'en'">
                      Actual
                      <b>{{ project.ActualCompletePercent }}%</b>
                    </h2>
                  </div>
                  <div class="col-lg-6 round-chart">
                    <h1 v-if="lang == 'ar'">الميزانية</h1>
                    <h1 v-if="lang == 'en'">Budget</h1>

                    <div class="col-12 ch halfcut2">
                      <halfcut-progress-lite
                        :baseContainer="`second-progress-${index}`"
                        :valueContainer="`second-value-container-${index}`"
                        color="#B7B471"
                        :data="
                          project.ContractValue == 0 ||
                          project.ContractValue == null
                            ? 0
                            : (parseInt(
                                project.PaidAmount.toString().replace(/,/g, '')
                              ) /
                                project.ContractValue) *
                              100
                        "
                      />
                      <half-cut-progress-v3
                        v-if="false"
                        :id="`halfcut-a${index}`"
                        color="#B7B471"
                        :data="
                          project.ContractValue == 0
                            ? 0
                            : (parseInt(project.PaidAmount) /
                                project.ContractValue) *
                              100
                        "
                        title="الميزانية"
                      />
                    </div>
                    <!-- {{ (halfcut.chartId1 = halfcut.chartId1 + 1) }}
                  {{ (halfcut.chartId2 = halfcut.chartId2 + 2) }} -->

                    <h2 v-if="lang == 'ar'">
                      المخطط
                      <b>{{ numeralFormatter(project.ContractValue) }}</b>
                    </h2>
                    <h2 v-if="lang == 'en'">
                      Planned
                      <b>{{ numeralFormatter(project.ContractValue) }}</b>
                    </h2>
                    <h2 v-if="lang == 'ar'">
                      المنصرف
                      <b>{{ numeralFormatter(project.PaidAmount) }}</b>
                    </h2>
                    <h2 v-if="lang == 'en'">
                      Spent
                      <b>{{ numeralFormatter(project.PaidAmount) }}</b>
                    </h2>
                  </div>
                </div>
              </div>
              <div class="bottom-description">
                <h1 v-if="lang == 'ar'">
                  <img
                    src="@/assets/images/icons/comment-feedback.svg"
                    alt="#"
                  />
                  إفادة الجهة المالكة
                </h1>
                <h1 v-if="lang == 'en'">
                  <img
                    src="@/assets/images/icons/comment-feedback.svg"
                    alt="#"
                  />
                  Comments from sector
                </h1>
                <p v-if="lang == 'ar'">
                  {{ project.sector_efada }}
                </p>
                <p v-if="lang == 'en'">
                  {{ project.sector_efada }}
                </p>
              </div>
              <div class="bottom-description">
                <h1 v-if="lang == 'ar'">
                  <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                  إفادة تقنية المعلومات
                </h1>
                <h1 v-if="lang == 'en'">
                  <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                  Comments from IT
                </h1>
                <p v-if="lang == 'ar'">
                  {{ project.AlignedComments }}
                </p>
                <p v-if="lang == 'en'">
                  {{ project.AlignedComments }}
                </p>
              </div>
              <div class="bottom-description">
                <h1 v-if="lang == 'ar'">
                  <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                  ملاحظات EPMO
                </h1>
                <h1 v-if="lang == 'en'">
                  <img src="@/assets/images/icons/write-feedback.svg" alt="#" />
                  Comments from EPMO
                </h1>
                <p v-if="lang == 'ar'">
                  {{ project.pmo_efada }}
                </p>
                <p v-if="lang == 'en'">
                  {{ project.pmo_efada }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 table-container" v-if="sectorData.tableView">
        <table class="table-responsive">
          <thead>
            <tr v-if="lang == 'ar'">
              <th>إسم المشروع</th>
              <th class="date">تاريخ البداية</th>
              <th class="date">تاريخ النهاية</th>
              <th class="status">الحالة</th>
              <th>إفادة الجهة المالكة</th>
              <th>إفادة تقنية المعلومات</th>
              <th>EPMO ملاحظات</th>
            </tr>
            <tr v-if="lang == 'en'">
              <th>Project Name</th>
              <th class="date">Start Date</th>
              <th class="date">Finish Date</th>
              <th class="status">Status</th>
              <th>Department Feedback</th>
              <th>Alignment Feedback</th>
              <th>PMO Feedback</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="shade"
              v-for="project in filteredProjects"
              :key="project.status"
            >
              <td>{{ project.ProjectName }}</td>
              <td class="center eng">
                {{ project.ProjectStartDate.substr(0, 10) }}
              </td>
              <td class="center eng">
                {{ project.ProjectFinishDate.substr(0, 10) }}
              </td>
              <td
                class="late center"
                v-if="lang == 'ar' && project.ProjectStatus == 'متأخر'"
              >
                <span>متأخر</span>
              </td>
              <td
                class="late center"
                v-if="lang == 'en' && project.ProjectStatus == 'متأخر'"
              >
                <span>Late</span>
              </td>
              <td
                class="onplanned center"
                v-if="lang == 'ar' && project.ProjectStatus == 'حسب المخطط'"
              >
                <span>حسب المخطط</span>
              </td>
              <td
                class="onplanned center"
                v-if="lang == 'en' && project.ProjectStatus == 'حسب المخطط'"
              >
                <span>As Planned</span>
              </td>
              <td
                class="completed center"
                v-if="
                  lang == 'ar' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span>تم الاطلاق(مكتمل)</span>
              </td>
              <td
                class="completed center"
                v-if="
                  lang == 'en' && project.ProjectStatus == 'تم الاطلاق(مكتمل)'
                "
              >
                <span>Completed</span>
              </td>
              <td
                class="expectedlate center"
                v-if="
                  lang == 'ar' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span>متوقع التأخير</span>
              </td>
              <td
                class="expectedlate center"
                v-if="
                  lang == 'en' &&
                  project.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'
                "
              >
                <span>Expected Late</span>
              </td>
              <td>{{ project.sector_efada }}</td>
              <td>{{ project.AlignedComments }}</td>
              <td>{{ project.pmo_efada }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <FooterUnfixed/>

  </div>
</template>





<script>
// Dependencies
import store from "@/store";
import router from "@/router";
// import Swal from 'sweetalert2'
import axios from "axios"; //uncomment when using api

// Components
import Loader from "@/components/loader.vue";
import ProjectLoader from "@/components/project-loader.vue";
import ThemeTogglerV3 from "@/components/theme-toggler-v3.vue";
import LangTogglerV3 from "@/components/lang-toggler-v3.vue";
import CircularPieV3 from "@/components/charts/circular-pie-v3.vue";
import PieV3 from "@/components/charts/pie-v3.vue";
import CircularProgressV3 from "@/components/charts/circular-progress-v3.vue";
import CircularPieFilterV3 from "@/components/charts/circular-pie-filter-v3.vue";
import HalfCutProgressV3 from "@/components/charts/half-cut-progress-v3.vue";
import HalfcutProgressLite from "@/components/charts/half-cut-progress-lite.vue";
import SearchFilter from "@/components/search-filter.vue";
import FooterUnfixed from "@/components/footer-unfixed.vue";


// import $ from 'jquery';

// Local data fetch for testign
import { projects } from "@/static/projectdataset.js";
import { risks } from "@/static/riskprojects.js";
import { milestones } from "@/static/milestones.js";

export default {
  name: "SectorDetail-dev",
  components: {
    Loader,
    ProjectLoader,
    ThemeTogglerV3,
    LangTogglerV3,
    CircularPieV3,
    PieV3,
    CircularProgressV3,
    CircularPieFilterV3,
    HalfCutProgressV3,
    HalfcutProgressLite,
    SearchFilter,
    FooterUnfixed
    
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    env() {
      return store.getters.getEnv;
    },
    projects() {
      return store.getters.getSectorProjects;
    },
    filteredProjects() {
      return store.getters.getFilteredSectorProjects;
    },
    activeTab() {
      return store.getters.getActiveTabSector;
    },
    activeFilter() {
      return store.getters.getActiveFilterSector;
    },
  },
  data() {
    return {
      isLoader: false,
      isProjectLoader: false,
      isTierVisible: false,
      isProjectAlignment: false,
      isMiscFilter: false,
      isInternalProject: false,
      isExternalProject: false,
      isProjectSector: false,
      isProjectRFP: false,
      isProjectClassification: false,
      isProjectType: false,
      isProjectDepartment: false,
      tabToggleFilter: "تم الاطلاق(مكتمل)",
      selectedSector: this.$route.query.key,
      sectorHealth: {
        onplanned: 0,
        completed: 0,
        expectedlate: 0,
        late: 0,
      },

      activeFilters: {
        health: "all",
        tier: "",
        alignment: "",
        misc: "",
        internal: "",
        projectType: "",
        sector: "",
        rfp: "",
        classification: "",
        department: "",
      },
      sectorData: {
        actualSpent: 0,
        approvedBudget: 0,
        contractValue: 0,
        tileView: true,
        tableView: false,
        risks: [],
        projects: [],
        milestones: [],
        projectSector: {
          isData: false,
          totalSectors: 0,
          labels: [],
        },
        internalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
        projectType: {
          isData: false,
          external: 0,
          internal: 0,
          changeRequest: 0,
        },
        externalProjects: {
          isData: false,
          executed: 0,
          planned: 0,
          opened: 0,
          closed: 0,
        },
        catEfada: {
          isData: false,
          labels: [],
          totalEfada: 0,
          colors: [
            { stop1: "#6F98B2", stop2: "#6F98B2" },
            { stop1: "#85ABC3", stop2: "#85ABC3" },
            { stop1: "#C3E8FF", stop2: "#C3E8FF" },
            { stop1: "#99D8FE", stop2: "#99D8FE" },
            { stop1: "#4EABE3", stop2: "#4EABE3" },
            { stop1: "#3091CC", stop2: "#3091CC" },
            { stop1: "#0B4C73", stop2: "#0B4C73" },
            { stop1: "#7CEDE8", stop2: "#7CEDE8" },
            { stop1: "#105B89", stop2: "#105B89" },
            { stop1: "#166B9E", stop2: "#166B9E" },
            { stop1: "#1978B2", stop2: "#1978B2" },
          ],
        },
        contractStatus: {
          isData: false,
          labels: [],
          totalContracts: 0,
          colors: [
            { stop1: "#85D7E0", stop2: "#85D7E0" },
            { stop1: "#9DF0FA", stop2: "#9DF0FA" },
            { stop1: "#78D3DC", stop2: "#78D3DC" },
            { stop1: "#5EBEC8", stop2: "#5EBEC8" },
            { stop1: "#399CA6", stop2: "#399CA6" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#2D7880", stop2: "#2D7880" },
            { stop1: "#13565C", stop2: "#13565C" },
            { stop1: "#238D98", stop2: "#238D98" },
            { stop1: "#2CA4B1", stop2: "#2CA4B1" },
            { stop1: "#31B1BF", stop2: "#31B1BF" },
            { stop1: "#3ABDCB", stop2: "#3ABDCB" },
          ],
        },
        department: {
          isData: false,
          labels: [],
          totalDepartments: 0,
          colors: [
            { stop1: "#6F98B2", stop2: "#6F98B2" },
            { stop1: "#85ABC3", stop2: "#85ABC3" },
            { stop1: "#C3E8FF", stop2: "#C3E8FF" },
            { stop1: "#99D8FE", stop2: "#99D8FE" },
            { stop1: "#4EABE3", stop2: "#4EABE3" },
            { stop1: "#3091CC", stop2: "#3091CC" },
            { stop1: "#0B4C73", stop2: "#0B4C73" },
            { stop1: "#7CEDE8", stop2: "#7CEDE8" },
            { stop1: "#105B89", stop2: "#105B89" },
            { stop1: "#166B9E", stop2: "#166B9E" },
            { stop1: "#1978B2", stop2: "#1978B2" },
          ],
        },
        budgets: {
          approvedBudget: 0,
          contractValue: 0,
          balance: 0,
          currentYear: 0,
          count: 0,
          actualSpent: 0,
        },
        progressChart: {
          allPercentageValue: 0,
          currentYearPercentageValue: 0,
        },
        pieChart: {
          isData: false,
          late: 0,
          expectedLate: 0,
          completed: 0,
          onplanned: 0,
        },
      },
    };
  },

  async updated() {
    this.trimmedTitles();
  },

  methods: {
    getOnlyDate: function (dateTime) {
      let date = new Date(dateTime);
      let year = date.getFullYear();
      let month =
        date.getMonth().toString().length > 1
          ? date.getMonth()
          : "0" + date.getMonth();
      let day =
        date.getDate().toString().length > 1
          ? date.getDate()
          : "0" + date.getDate();
      month = parseInt(month) + 1;
      let dateWithoutTime = day + "-" + month + "-" + year;
      return dateWithoutTime;
    },
    calculateProjectDateProgress(projectStartDate, projectFinishDate) {

      if (new Date(projectStartDate) > new Date()) {
        console.log("0 Percent");
        return 0;
      } else if (new Date(projectFinishDate) < new Date()) {
        return 100;
      } else {
        const startDate = new Date(projectStartDate);
        const finishDate = new Date(projectFinishDate);
        const today = new Date();
        const diffTimeFinishStart = Math.abs(finishDate - startDate);
        let totalDays = Math.ceil(diffTimeFinishStart / (1000 * 60 * 60 * 24));
        const diffTimeTodayStartDate = Math.abs(today - startDate);
        const diffDays = Math.ceil(
          diffTimeTodayStartDate / (1000 * 60 * 60 * 24)
        );

        if (totalDays == 0) {
          totalDays = 1;
        }
        return ((parseInt(diffDays) / parseInt(totalDays)) * 100).toFixed(2);
      }
    },
    navigate: function (page) {
      router.push(page);
    },

    openTierFilter: function () {
      this.isTierVisible = !this.isTierVisible;
      this.isProjectAlignment = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openAlignmentFilter: function () {
      this.isProjectAlignment = !this.isProjectAlignment;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openInternalProjects: function () {
      this.isInternalProject = !this.isInternalProject;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openProjectType: function () {
      this.isProjectType = !this.isProjectType;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openExternalProjects: function () {
      this.isExternalProject = !this.isExternalProject;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openProjectSector: function () {
      this.isProjectSector = !this.isProjectSector;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openRFP: function () {
      this.isProjectRFP = !this.isProjectRFP;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openProjectClassification: function () {
      this.isProjectClassification = !this.isProjectClassification;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectDepartment = false;
    },
    openMiscFilter: function () {
      this.isMiscFilter = !this.isMiscFilter;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
      this.isProjectDepartment = false;
    },
    openDepartmentFilter: function () {
      this.isProjectDepartment = !this.isProjectDepartment;
      this.isProjectAlignment = false;
      this.isTierVisible = false;
      this.isMiscFilter = false;
      this.isInternalProject = false;
      this.isProjectType = false;
      this.isProjectSector = false;
      this.isProjectRFP = false;
      this.isProjectClassification = false;
    },
    filterProjects: async function (filter) {
      // Showing Project Loader
      this.isProjectLoader = true;
      this.activeFilters.health = filter;

      this.isProjectLoader = true;

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByTier: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.tier = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByAlignment: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.alignment = filter;
      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByMisc: async function (filter) {
      // Showing Loader

      this.isProjectLoader = true;
      this.activeFilters.misc = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByInternal: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.internal = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByProjectType: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.projectType = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsBySector: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.sector = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByRFP: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.rfp = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByClassification: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.classification = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    filterProjectsByDepartment: async function (filter) {
      // Showing Loader
      this.isProjectLoader = true;
      this.activeFilters.department = filter;

      // Erasing Search Text
      // document.querySelector("#search-filter").value = "";

      // Applying New Filter
      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();
      this.applyDepartment();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    applyHealth() {
      // Applying New Filter
      if (this.activeFilters.health == "all") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getSectorProjects
        );
      } else {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getSectorProjects.filter(
            (item) => item.ProjectStatus == this.activeFilters.health
          )
        );
        // }
      }
    },
    applyTier() {
      if (this.activeFilters.tier != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.Priority == this.activeFilters.tier
          )
        );
      }
    },
    applyAlignment() {
      if (this.activeFilters.alignment != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter((item) => {
            if (
              this.activeFilters.alignment == "نعم" ||
              this.activeFilters.alignment == "لا ينطبق" ||
              this.activeFilters.alignment == "TBD"
            ) {
              return item.IsAligned == this.activeFilters.alignment;
            } else if (
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "النطاق") ||
              (item.IsAligned == "لا" &&
                this.activeFilters.alignment == "التواريخ و النطاق")
            ) {
              return item.NotAligned == this.activeFilters.alignment;
            }
          })
        );
      }
    },
    applyMisc() {
      if (this.activeFilters.misc == "مبادرات مجلس الإدارة") {
        // Applying New Filter
        store.dispatch(
          "setFilteredSectorProjects",

          store.getters.getFilteredSectorProjects.filter(
            (item) => item.boardinitiative == "نعم"
          )
        );
      }

      if (this.activeFilters.misc == "مشاريع السنة الحالي") {
        // Applying New Filter
        store.dispatch(
          "setFilteredSectorProjects",

          store.getters.getFilteredSectorProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
      //
      if (this.activeFilters.misc == "مشاريع السنة القادم") {
        store.dispatch(
          "setFilteredSectorProjects",

          store.getters.getFilteredSectorProjects.filter((item) => {
            let date = new Date(item.ProjectFinishDate);
            if (
              date.getFullYear() == new Date().getFullYear() + 1 &&
              item.IsAligned == "نعم"
            ) {
              return item;
            }
          })
        );
      }
    },
    applyInternal() {
      if (this.activeFilters.internal != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) =>
              //  item.ProjectType == "داخلي" &&
              item.ProjectPhase == this.activeFilters.internal
          )
        );
      }
    },
    applyExternal() {
      if (this.activeFilters.external != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) =>
              item.ProjectType == "خارجي" &&
              item.ProjectPhase == this.activeFilters.external
          )
        );
      }
    },
    applyProjectType() {
      if (this.activeFilters.projectType != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.ProjectType == this.activeFilters.projectType
          )
        );
      }
    },
    applySector() {
      if (this.activeFilters.sector != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.ProjectSector == this.activeFilters.sector
          )
        );
      }
    },
    applyRFP() {
      if (this.activeFilters.rfp != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.ContractStatus == this.activeFilters.rfp
          )
        );
      }
    },
    applyClassification() {
      if (this.activeFilters.classification != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.cat_efada == this.activeFilters.classification
          )
        );
      }
    },
    applyDepartment() {
      if (this.activeFilters.department != "") {
        store.dispatch(
          "setFilteredSectorProjects",
          store.getters.getFilteredSectorProjects.filter(
            (item) => item.Department == this.activeFilters.department
          )
        );
      }
    },
    makeActiveFilterNone: function (index) {
      if (index == 0) {
        this.activeFilters.health = "all";
      }
      if (index == 1) {
        this.activeFilters.tier = "";
      }
      if (index == 2) {
        this.activeFilters.alignment = "";
      }
      if (index == 3) {
        this.activeFilters.misc = "";
      }
      if (index == 4) {
        this.activeFilters.internal = "";
      }
      if (index == 5) {
        this.activeFilters.projectType = "";
      }
      if (index == 6) {
        this.activeFilters.sector = "";
      }
      if (index == 7) {
        this.activeFilters.rfp = "";
      }
      if (index == 8) {
        this.activeFilters.classification = "";
      }
      if (index == 9) {
        this.activeFilters.department = "";
      }

      this.isProjectLoader = true;

      this.applyHealth();
      this.applyTier();
      this.applyAlignment();
      this.applyMisc();
      this.applyInternal();
      this.applyProjectType();
      this.applySector();
      this.applyRFP();
      this.applyClassification();

      setTimeout(() => {
        this.isProjectLoader = false;
      }, 1000);
    },
    changeProjectView: function (view) {
      if (view == "table") {
        this.sectorData.tableView = true;
        this.sectorData.tileView = false;
      }
      if (view == "tile") {
        this.sectorData.tableView = false;
        this.sectorData.tileView = true;
      }
    },
    calculateProjectSector: function () {
      const uniques = this.sectorData.projects
        .map((item) => item.ProjectSector)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.sectorData.projectSector.labels.push(feed);
      }
    },
    switchTabToggle: function (filter) {
      this.isProjectLoader = true;
      this.tabToggleFilter = filter;
      this.filterProjects(filter);

      window.scrollTo({
        top: document.getElementById("databased-row").offsetTop,
        behavior: "smooth",
      });
    },
    numeralFormatter: function (number) {
      number = number.toString().replace(/,/g, "");
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "sar",
        minimumFractionDigits: 0,
      });
      if (number < 1000000 && number > 1000) {
        // Anything less than a million
        return formatter.format(number) + "K";
      } else if (number < 1000000000 && number > 1000000) {
        // Anything less than a billion
        number = number / 1000000;
        return formatter.format(number) + "M";
      } else if (number > 1000000000) {
        // At least a billion
        number = number / 1000000000;
        return formatter.format(number) + "B";
      } else {
        return formatter.format(number);
      }
    },
    insertionSort: function (inputArr) {
      let n = inputArr.length;
      for (let i = 1; i < n; i++) {
        // Choosing the first element in our unsorted subarray
        let current = inputArr[i];
        // The last element of our sorted subarray
        let j = i - 1;
        while (j > -1 && current.value < inputArr[j].value) {
          inputArr[j + 1] = inputArr[j];
          j--;
        }
        inputArr[j + 1] = current;
      }
      // return inputArr;
    },
    calculateSectorHealthCount: function () {
      this.sectorHealth.onplanned = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "حسب المخطط"
      ).length;
      this.sectorHealth.completed = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
      ).length;
      this.sectorHealth.expectedlate = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
      ).length;
      this.sectorHealth.late = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "متأخر"
      ).length;
    },
    calculateInternalProjects: function () {
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        if (this.sectorData.projects[i].ProjectType == "داخلي") {
          if (this.sectorData.projects[i].ProjectPhase == "التنفيذ") {
            this.sectorData.internalProjects.executed++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "التخطيط") {
            this.sectorData.internalProjects.planned++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "الإغلاق") {
            this.sectorData.internalProjects.closed++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "البدء") {
            this.sectorData.internalProjects.opened++;
          }
        }
      }
      this.sectorData.internalProjects.isData = true;
    },
    calculateExternalProjects: function () {
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        if (this.sectorData.projects[i].ProjectType == "خارجي") {
          if (this.sectorData.projects[i].ProjectPhase == "التنفيذ") {
            this.sectorData.externalProjects.executed++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "التخطيط") {
            this.sectorData.externalProjects.planned++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "الإغلاق") {
            this.sectorData.externalProjects.closed++;
          }
          if (this.sectorData.projects[i].ProjectPhase == "البدء") {
            this.sectorData.externalProjects.opened++;
          }
        }
      }
      this.sectorData.externalProjects.isData = true;
    },
    calculateProjectType: function () {
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        if (this.sectorData.projects[i].ProjectType == "داخلي") {
          this.sectorData.projectType.internal++;
        }
        if (this.sectorData.projects[i].ProjectType == "خارجي") {
          this.sectorData.projectType.external++;
        }
        if (this.sectorData.projects[i].ProjectType == "طلب التغيير") {
          this.sectorData.projectType.changeRequest++;
        }
      }
      this.sectorData.projectType.isData = true;
    },
    calculateCatEfadaStatus: function () {
      let newData = this.sectorData.projects.filter(
        (item) => item.cat_efada != null && item.cat_efada != ""
      );
      const uniques = newData
        .filter((item) => item.ProjectSector == this.selectedSector)
        .map((item) => item.cat_efada.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.sectorData.catEfada.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        for (let j = 0; j < this.sectorData.catEfada.labels.length; j++) {
          if (
            this.sectorData.projects[i].cat_efada ==
            this.sectorData.catEfada.labels[j].key
          ) {
            this.sectorData.catEfada.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.sectorData.catEfada.labels.length; j++) {
        this.sectorData.catEfada.totalEfada +=
          this.sectorData.catEfada.labels[j].value;
      }
      this.insertionSort(this.sectorData.catEfada.labels);

      this.sectorData.catEfada.isData = true;
    },
    calculateContractStatus: function () {
      let newData = this.sectorData.projects.filter(
        (item) => item.ContractStatus != null && item.ContractStatus != ""
      );
      const uniques = newData
        .map((item) => item.ContractStatus.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.sectorData.contractStatus.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        for (let j = 0; j < this.sectorData.contractStatus.labels.length; j++) {
          if (
            this.sectorData.projects[i].ContractStatus ==
            this.sectorData.contractStatus.labels[j].key
          ) {
            this.sectorData.contractStatus.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.sectorData.contractStatus.labels.length; j++) {
        this.sectorData.contractStatus.totalContracts +=
          this.sectorData.contractStatus.labels[j].value;
      }
      this.insertionSort(this.sectorData.contractStatus.labels);
      this.sectorData.contractStatus.isData = true;
    },
    calculateBudgets: function () {
      // Approved Budget
      this.sectorData.projects.filter((item) => {
        if (item.ProjectSector == this.selectedSector) {
          this.sectorData.budgets.approvedBudget += parseInt(
            item.ApprovedBudget
          );
        }
      });

      // Contract Value Budget
      this.sectorData.projects.filter((item) => {
        if (item.ProjectSector == this.selectedSector) {
          this.sectorData.budgets.contractValue += parseInt(item.ContractValue);
        }
      });

      // Contract Value Budget
      this.sectorData.budgets.balance =
        this.sectorData.budgets.approvedBudget -
        this.sectorData.budgets.contractValue;

      // Contract Value Budget for current Year
      this.sectorData.projects.filter((item) => {
        if (item.ProjectSector == this.selectedSector) {
          let date = new Date(item.ProjectStartDate);
          if (date.getFullYear() == new Date().getFullYear()) {
            this.sectorData.budgets.currentYear += parseInt(item.ContractValue);
          }
        }
      });

      // Calculating Risk based on Sector Wise
      this.sectorData.budgets.count = this.sectorData.risks.length;

      // Actual Spent current Year
      this.sectorData.projects.filter((item) => {
        if (item.ProjectSector == this.selectedSector) {
          let date = new Date(item.ProjectStartDate);
          if (date.getFullYear() == new Date().getFullYear()) {
            this.sectorData.budgets.actualSpent += parseInt(item.PaidAmount);
          }
        }
      });

      // Applying Formatter
      this.sectorData.budgets.approvedBudget = this.numeralFormatter(
        this.sectorData.budgets.approvedBudget
      );
      this.sectorData.budgets.contractValue = this.numeralFormatter(
        this.sectorData.budgets.contractValue
      );
      this.sectorData.budgets.balance = this.numeralFormatter(
        this.sectorData.budgets.balance
      );
      this.sectorData.budgets.currentYear = this.numeralFormatter(
        this.sectorData.budgets.currentYear
      );
      this.sectorData.budgets.actualSpent = this.numeralFormatter(
        this.sectorData.budgets.actualSpent
      );
    },
    calculatePercentageValue: function () {
      this.sectorData.projects.filter((item) => {
        if (item.ProjectSector == this.selectedSector) {
          this.sectorData.actualSpent += parseInt(item.PaidAmount);
          this.sectorData.contractValue += parseInt(item.ContractValue);
        }
      });

      this.sectorData.progressChart.allPercentageValue = (
        (this.sectorData.actualSpent / this.sectorData.contractValue) *
        100
      ).toFixed(0);
    },
    calculatePiePercentageValue: function () {
      this.sectorData.pieChart.late = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "متأخر"
      ).length;
      this.sectorData.pieChart.expectedLate = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة"
      ).length;
      this.sectorData.pieChart.onplanned = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "حسب المخطط"
      ).length;
      this.sectorData.pieChart.completed = this.sectorData.projects.filter(
        (item) => item.ProjectStatus == "تم الاطلاق(مكتمل)"
      ).length;

      this.sectorData.pieChart.isData = true;
    },
    calculateProjectDepartments: function () {
      let newData = this.sectorData.projects.filter(
        (item) => item.Department != null && item.Department != ""
      );
      const uniques = newData
        .filter((item) => item.ProjectSector == this.selectedSector)
        .map((item) => item.Department.trim())
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < uniques.length; i++) {
        const feed = {};
        feed.key = uniques[i];
        feed.value = 0;
        this.sectorData.department.labels.push(feed);
      }

      // Now getting count
      for (let i = 0; i < this.sectorData.projects.length; i++) {
        for (let j = 0; j < this.sectorData.department.labels.length; j++) {
          if (
            this.sectorData.projects[i].Department ==
            this.sectorData.department.labels[j].key
          ) {
            this.sectorData.department.labels[j].value++;
          }
        }
      }
      for (let j = 0; j < this.sectorData.department.labels.length; j++) {
        this.sectorData.department.totalEfada +=
          this.sectorData.department.labels[j].value;
      }
      this.insertionSort(this.sectorData.department.labels);

      this.sectorData.department.isData = true;
    },
    disableDropdowns() {
      var binder = this;
      document.addEventListener("DOMContentLoaded", function () {
        let body = document.querySelector("body");
        body.addEventListener("click", function (e) {
          if (
            !(
              e.target.classList.contains("dropdown-filter") ||
              e.target.parentNode.classList.contains("dropdown-filter")
            )
          ) {
            console.log("in if");
            binder.isTierVisible = false;
            binder.isProjectAlignment = false;
            binder.isMiscFilter = false;
            binder.isInternalProject = false;
            binder.isExternalProject = false;
            binder.isProjectSector = false;
            binder.isProjectRFP = false;
            binder.isProjectClassification = false;
            binder.isProjectType = false;
          }
        });
      });
    },

    trimmedTitles: function () {
      let headingTitle = document.querySelectorAll(".trimed-title h1");
      headingTitle.forEach(function (item) {
        item.style.minHeight = "65px";
        item.style.maxHeight = "65px";
        item.style.overflow = "hidden";
        item.style.padding = "15px";
      });
    },
  },
  async mounted() {
    // Fetching from api uncomment below three lines if using api
    if (this.env == "prod") {
      try {
        this.isLoader = true;
        const response = await axios.get(
          `https://pmoapi.sdb.gov.sa/api/proj/4/${this.selectedSector}`,

          { withCredentials: true }
        );
        console.log(
          `https://pmoapi.sdb.gov.sa/api/proj/5&key=${this.selectedSector}`
        );

        this.sectorData.milestones = JSON.parse(response.data[2]);

        this.sectorData.projects = JSON.parse(response.data[0]).filter(
          (item) => item.ProjectSector == this.selectedSector
        );
        this.sectorData.risks = JSON.parse(response.data[1]).filter(
          (item) => item.ProjectSector == this.selectedSector
        );
        this.sectorData.projects.map((item) => {
          if (item.ContractValue == null || item.ContractValue == "") {
            item.ContractValue = 0;
          }
          if (item.ApprovedBudget == null || item.ApprovedBudget == "") {
            item.ApprovedBudget = 0;
          }
          if (item.PaidAmount == null || item.PaidAmount == "") {
            item.PaidAmount = 0;
          }
          if (item.YearBudget == null || item.YearBudget == "") {
            item.YearBudget = 0;
          }
          if (item.SpentYearBudget == null || item.SpentYearBudget == "") {
            item.SpentYearBudget = 0;
          }
        });
        this.isLoader = false;
      } catch (error) {
        console.log(error);
      }
    }

    if (this.env == "dev") {
      // console.log(
      //   `https://pmoapi.sdb.gov.sa/api/proj/5&key=${this.selectedSector}`
      // );
      // Fetching from local comment below three lines if using api
      this.sectorData.projects = projects.filter(
        (item) => item.ProjectSector == this.selectedSector
      );
      this.sectorData.risks = risks.filter(
        (item) => item.ProjectSector == this.selectedSector
      );
      this.sectorData.projects = projects;
      this.sectorData.milestones = milestones;

      this.sectorData.projects.map((item) => {
        if (item.ContractValue == null || item.ContractValue == "") {
          item.ContractValue = 0;
        }
        if (item.ApprovedBudget == null || item.ApprovedBudget == "") {
          item.ApprovedBudget = 0;
        }
        if (item.PaidAmount == null || item.PaidAmount == "") {
          item.PaidAmount = 0;
        }
        if (item.YearBudget == null || item.YearBudget == "") {
          item.YearBudget = 0;
        }
        if (item.SpentYearBudget == null || item.SpentYearBudget == "") {
          item.SpentYearBudget = 0;
        }
      });
    }

    // Calculating Project Sector
    this.calculateProjectSector();

    // Calculating Project Sector Health
    this.calculateSectorHealthCount();

    // Calculate Pie Filter chart value and percentage of Internal Projects Sector Wise
    this.calculateInternalProjects();

    // Calculate Pie Filter chart value and percentage of External Projects Sector Wise
    this.calculateExternalProjects();
    this.calculateProjectType();

    // Calculate Pie Filter chart value and percentage of Contract Value Sector Wise
    this.calculateContractStatus();

    // Calculate Pie Filter chart value and percentage of Cat Efada Sector Wise
    this.calculateCatEfadaStatus();

    // Calculate Budgets Sector Wise
    this.calculateBudgets();

    // Calculate Progress Percentage
    this.calculatePercentageValue();

    // Calculate Pie Filter Percentage based on Sector Wise
    this.calculatePiePercentageValue();

    // Calculate Project Department Labels
    this.calculateProjectDepartments();

    store.dispatch("setSectorProjects", this.sectorData.projects);
    store.dispatch("setFilteredSectorProjects", this.sectorData.projects);

    // Disable Dropdowns
    this.disableDropdowns();

    //removing duplicate checked Schedule icon
    setTimeout(function () {
      let tileHeads = document.querySelectorAll(".tilehead");
      tileHeads.forEach(function (item) {
        let taskChecks = item.querySelectorAll(".task-check");
        // console.log(taskChecks);

        taskChecks.forEach(function (item, index) {
          if (index > 0) {
            item.remove();
          }
        });
      });
    }, 1000);

    //trimming titles
    this.trimmedTitles();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";

body.ar {
  direction: rtl;
}
body.en {
  direction: ltr;
}

body.theme-light {
  background: $primary-background-light-v3;
}
body.theme-dark {
  background: $primary-background-dark-v3;
}
body.theme-medium {
  background: $primary-background-medium-v3;
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
@import "@/assets/css/common.scss";

body.theme-dark.ar {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-right: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }
    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      left: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-left: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      }
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      // margin-left: 45px;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      &:nth-child(3n) {
        margin-left: 0;
      }
      .floating-number {
        position: absolute;
        top: 10px;
        left: 18px;
        width: 47px;
        height: 47px;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }
      .tilehead {
        background: $v3-dark-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        .tilehead-icon {
          margin-left: 20px;
        }
      }

      h1 {
        // letter-spacing: 1.91px;
        @include apply-font($almarai, 700, 16px, #4a7780);
      }

      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font($sourcesanspro, 400, 21px, #fff);
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorderDarkV3;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
        border-radius: 13px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: #1c4567;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font($sourcesanspro, 400, 21px, #fff);
        }
      }
      .budget-tile:last-child {
        margin-left: 0px;
      }
    }
  }
  #databased-row {
    padding-bottom: 66px;
  }

  .filter-based-data > h1 {
    @include apply-font($almarai, 300, 20px, $v3-dark-primarytext);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 33px;

  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-left: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorderDarkV3;
    box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
    cursor: pointer;
    a {
      text-decoration: none;

      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid rgba(255, 255, 255, 0.03);
        padding-bottom: 26px;

        .task-check {
          display: flex;
          // justify-content: flex-end;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
          text-align: center;
        }

        h2 span {
          @include apply-font($almarai, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, #fff);
          }
          .progress {
            background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2),
                rgba(0, 0, 0, 0.2)
              ),
              #305776 !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;

            .progress-bar {
              background: #ffffff;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, rgba(13, 44, 68, 1));
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              // margin-left: 40% !important;
              background: $v3-expectedlate !important;
            }
            .late {
              // margin-left: 60% !important;
              background: $v3-late !important;
            }

            .completed {
              margin-left: 80% !important;
              background: $v3-completed !important;
            }
          }
        }
      }
    }

    .round-chart {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h1 {
        @include apply-font($almarai, 700, 10px, #91b3ba);
      }

      #chart {
        img {
          margin-top: -20px;
          margin-left: 30px;
        }
      }

      h2 {
        margin-bottom: 15px;
        @include apply-font($almarai, 700, 10px, #91b3ba);

        b {
          @include apply-font($sourcesanspro, 700, 16px, $v3-dark-primarytext);
          margin-right: 8px;
        }
      }
    }

    .bottom-description {
      margin-top: 24px;
      margin-right: 20px;

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
        margin-bottom: 15px;

        img {
          margin-left: 17px;
        }
      }

      p {
        @include apply-font($almarai, 700, 13px, #91b3ba);

        img {
          margin-left: 17px;
        }
      }
      &:nth-child(1n) {
        h1 {
          color: rgba(26, 177, 199, 1) !important;
        }
      }
      &:nth-child(2n) {
        h1 {
          color: rgba(118, 224, 239, 1) !important;
        }
      }
      &:nth-child(3n) {
        h1 {
          color: rgba(39, 222, 191, 1) !important;
        }
      }
    }

    .bottom-description:last-child {
      margin-top: 20px;
    }
  }

  .filter-data-tile:last-child {
    margin-left: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, $v3-dark-primarytext);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #000000;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      right: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: $v3-dark-primarytext;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: linear-gradient(
        152.47deg,
        rgba(255, 255, 255, 0.04) 0.74%,
        rgba(255, 255, 255, 0) 97.97%
      );
      filter: drop-shadow(0px 11px 81px rgba(0, 0, 0, 0.26));
      border: 1px solid rgba(12, 46, 46, 1);
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($almarai, 800, 14px, #4a7780);
      }

      &.active.all {
        background: $v3-all;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }
      .mark.onplanned {
        background: $v3-onplanned;
      }

      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .table-container {
    padding: 0px 10px 37px 0px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          // letter-spacing: 1.91px;
          @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-dark-table-stripes;
        }

        td {
          // letter-spacing: 1.91px;
          @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          // border-left: 1px solid #CEDCE3;
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font($sourcesanspro, 400, 12px, $v3-dark-primarytext);
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff;
          white-space: nowrap;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onplanned;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, #fff);

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-left: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
        border: 1px solid #fff;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-right: 20px;
        margin-left: 5px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
    }
  }

  .sector-status {
    padding-top: 5px;
    @include apply-font($almarai, 400, 18px, $v3-dark-primarytext);
    margin-top: 10px;
  }
}
body.theme-medium.ar {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-right: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }

    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      left: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-left: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      }
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }

        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      &:nth-child(3n) {
        margin-left: 0;
      }
      .floating-number {
        position: absolute;
        top: 10px;
        left: 18px;
        width: 47px;
        height: 47px;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }

      .tilehead {
        background: $v3-medium-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .tilehead-icon {
          margin-left: 20px;
        }
      }

      h1 {
        // letter-spacing: 1.91px;
        @include apply-font($almarai, 700, 16px, #4a7780);
      }

      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font(
              $sourcesanspro,
              400,
              21px,
              $v3-medium-primarytext
            );
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorderMediumV3;
        box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
        border-radius: 13px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: $v3-medium-header-color;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font(
            $sourcesanspro,
            400,
            21px,
            $v3-medium-primarytext
          );
        }
      }
      .budget-tile:last-child {
        margin-left: 0px;
      }
    }
  }
  #databased-row {
    padding-bottom: 66px;
  }

  .filter-based-data > h1 {
    @include apply-font($almarai, 300, 20px, $v3-medium-primarytext);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 33px;
  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-left: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorderMediumV3;
    box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
    cursor: pointer;

    a {
      text-decoration: none !important;

      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid #dee6e6;
        padding-bottom: 26px;

        .task-check {
          display: flex;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
          text-align: center;
        }

        h2 span {
          @include apply-font($almarai, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, rgba(28, 69, 103, 1));
          }
          .progress {
            background: #b4d1d7 !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;
            .progress-bar {
              background: #ffffff;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, rgba(13, 44, 68, 1));
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              background: $v3-expectedlate !important;
            }
            .late {
              background: $v3-late !important;
            }

            .completed {
              margin-left: 80% !important;
              background: $v3-completed !important;
            }
          }
        }
      }
    }

    .round-chart {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      h1 {
        @include apply-font($almarai, 700, 10px, #527a7a);
      }

      #chart {
        img {
          margin-top: -20px;
          margin-left: 30px;
        }
      }

      h2 {
        margin-bottom: 15px;
        @include apply-font($almarai, 700, 10px, #527a7a);

        b {
          @include apply-font(
            $sourcesanspro,
            700,
            16px,
            $v3-medium-primarytext
          );
          margin-right: 8px;
        }
      }
    }

    .bottom-description {
      margin-top: 24px;
      margin-right: 20px;

      h1 {
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        margin-bottom: 15px;

        img {
          margin-left: 17px;
        }
      }

      p {
        @include apply-font($almarai, 700, 13px, #527a7a);

        img {
          margin-left: 17px;
        }
      }
      &:nth-child(1n) {
        h1 {
          color: rgba(16, 60, 100, 1) !important;
        }
      }
      &:nth-child(2n) {
        h1 {
          color: rgba(16, 119, 121, 1) !important;
        }
      }
      &:nth-child(3n) {
        h1 {
          color: rgba(28, 94, 18, 1) !important;
        }
      }
    }

    .bottom-description:last-child {
      margin-top: 20px;
    }
  }

  .filter-data-tile:last-child {
    margin-left: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #fff);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #e7e7e7;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      right: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: #fff;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: #ffffff;
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($almarai, 800, 14px, #4a7780);
      }

      &.active.all {
        background: #1978b2;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }

      .mark.onplanned {
        background: $v3-onplanned;
      }

      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .table-container {
    padding: 0px 10px 37px 0px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          @include apply-font($almarai, 700, 12px, #fff);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        &:nth-child(even) {
          background: $v3-medium-table-stripes-even;
        }

        td {
          @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font(
            $sourcesanspro,
            400,
            12px,
            $v3-medium-primarytext
          );
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff !important;
          white-space: nowrap;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onplanned;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-left: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
        border: 1px solid $v3-medium-primarytext;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-right: 20px;
        margin-left: 5px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 18px, $v3-medium-primarytext);
    }
  }

  .sector-status {
    padding-top: 5px;
    @include apply-font($almarai, 400, 18px, $v3-medium-primarytext);
    margin-top: 10px;
  }
}
body.theme-light.ar {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-right: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }

    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      left: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-left: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      }
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 35px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      &:nth-child(3n) {
        margin-left: 0;
      }
      .floating-number {
        position: absolute;
        top: 10px;
        left: 18px;
        width: 47px;
        height: 47px;
        background: #fff;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }

      .tilehead {
        background: $v3-light-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        border: 1px solid #e3e3e3;
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .tilehead-icon {
          margin-left: 20px;
        }
      }

      h1 {
        @include apply-font($almarai, 700, 16px, #4a7780);
      }

      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font(
              $sourcesanspro,
              400,
              21px,
              $v3-medium-primarytext
            );
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorder;
        box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
        border-radius: 13px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: $v3-medium-header-color;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font(
            $sourcesanspro,
            400,
            21px,
            $v3-medium-primarytext
          );
        }
      }
      .budget-tile:last-child {
        margin-left: 0px;
      }
    }
  }
  #databased-row {
    padding-bottom: 66px;
  }

  .filter-based-data > h1 {
    @include apply-font($almarai, 300, 20px, #103c64);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 66px;

    .custom-filter {
      width: 136px;
      height: 33px;
      border: 1px solid #1a4f4f;
      box-sizing: border-box;
      border-radius: 16.5px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: 20px;

      h1 {
        @include apply-font($sourcesanspro, 700, 14px, #103c64);
        position: relative;

        img {
          position: absolute;
          right: -20px;
          top: 6px;
        }
      }
    }
  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-left: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorder;
    box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
    cursor: pointer;

    a {
      text-decoration: none !important;
      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid #dee6e6;
        padding-bottom: 26px;

        .task-check {
          display: flex;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }

        h1 {
          @include apply-font($almarai, 400, 14px, #103c64);
          text-align: center;
        }

        h2 span {
          @include apply-font($almarai, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, rgba(28, 69, 103, 1));
          }
          .progress {
            background: #ebebeb !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;
            .progress-bar {
              background: #103c64;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, #ffffff);
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              background: $v3-expectedlate !important;
            }
            .late {
              background: $v3-late !important;
            }

            .completed {
              background: $v3-completed !important;
            }
          }
        }
      }

      .round-chart {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        h1 {
          @include apply-font($almarai, 700, 10px, #103c64);
        }

        #chart {
          img {
            margin-top: -20px;
            margin-left: 30px;
          }
        }

        h2 {
          margin-bottom: 15px;
          @include apply-font($almarai, 700, 10px, #90b2b9);

          b {
            @include apply-font($sourcesanspro, 700, 16px, #103c64);
            margin-right: 8px;
          }
        }
      }

      .bottom-description {
        margin-top: 24px;
        margin-right: 20px;

        h1 {
          @include apply-font($almarai, 400, 14px, #103c64);
          margin-bottom: 15px;

          img {
            margin-left: 17px;
          }
        }

        p {
          @include apply-font($almarai, 700, 13px, #90b2b9);

          img {
            margin-left: 17px;
          }
        }
        &:nth-child(1n) {
          h1 {
            color: rgba(19, 156, 176, 1) !important;
          }
        }
        &:nth-child(2n) {
          h1 {
            color: rgba(72, 193, 210, 1) !important;
          }
        }
        &:nth-child(3n) {
          h1 {
            color: rgba(27, 183, 156, 1) !important;
          }
        }
      }

      .bottom-description:last-child {
        margin-top: 20px;
      }
    }
  }

  .filter-data-tile:last-child {
    margin-left: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #103c64);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #e7e7e7;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      right: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: #fff;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: $v3-light-header-color;
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($almarai, 800, 14px, #103c64);
      }

      &.active.all {
        background: $v3-all;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }

      .mark.onplanned {
        background: $v3-onplanned;
      }
      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }

  .table-container {
    padding: 0px 10px 0px 10px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          @include apply-font($almarai, 700, 12px, #fff);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        td {
          @include apply-font($almarai, 400, 12px, #103c64);
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font($sourcesanspro, 400, 12px, #103c64);
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff !important;
          white-space: nowrap;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onplanned;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, $v3-light-primarytext);

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-left: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
        border: 1px solid $v3-light-primarytext;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-right: 20px;
        margin-left: 5px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 18px, $v3-light-primarytext);
    }
  }
  .sector-status {
    @include apply-font($almarai, 400, 18px, $v3-light-primarytext);
    margin-top: 10px;
  }
}

body.theme-dark.en {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-left: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }

    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      right: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-right: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      }
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-dark-secondarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #fff);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }
        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      @include applyGradientBorderDarkV3;
      box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

      .floating-number {
        position: absolute;
        top: 10px;
        right: 18px;
        width: 47px;
        height: 47px;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }

      .tilehead {
        background: $v3-dark-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);

        .tilehead-icon {
          margin-right: 20px;
        }
      }

      h1 {
        @include apply-font($sourcesanspro, 700, 16px, #4a7780);
      }

      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font($sourcesanspro, 400, 21px, #fff);
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorderDarkV3;
        box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
        border-radius: 13px;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: #1c4567;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font($sourcesanspro, 400, 21px, #fff);
        }
      }
      .budget-tile:last-child {
        margin-right: 0px;
      }
    }
  }
  .filter-based-data > h1 {
    @include apply-font($sourcesanspro, 300, 20px, #103c64);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 66px;

    .custom-filter {
      width: 136px;
      height: 33px;
      border: 1px solid #1a4f4f;
      box-sizing: border-box;
      border-radius: 16.5px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: 20px;

      h1 {
        @include apply-font($sourcesanspro, 700, 14px, #103c64);
        position: relative;

        img {
          position: absolute;
          right: -20px;
          top: 6px;
        }
      }
    }
  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-right: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorderDarkV3;
    box-shadow: 0px 11px 81px rgba(0, 0, 0, 0.26);
    cursor: pointer;

    a {
      text-decoration: none !important;
      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid rgba(255, 255, 255, 0.03);
        padding-bottom: 26px;

        .task-check {
          display: flex;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
          text-align: center;
        }

        h2 span {
          @include apply-font($sourcesanspro, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, #fff);
          }
          .progress {
            background: linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2),
                rgba(0, 0, 0, 0.2)
              ),
              #305776 !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;
            .progress-bar {
              background: #ffffff;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, rgba(13, 44, 68, 1));
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              background: $v3-expectedlate !important;
            }
            .late {
              background: $v3-late !important;
            }

            .completed {
              background: $v3-completed !important;
            }
          }
        }
      }

      .round-chart {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        h1 {
          @include apply-font($sourcesanspro, 700, 10px, #91b3ba);
        }

        #chart {
          img {
            margin-top: -20px;
            margin-left: 30px;
          }
        }

        h2 {
          margin-bottom: 15px;
          @include apply-font($sourcesanspro, 700, 10px, #91b3ba);

          b {
            @include apply-font(
              $sourcesanspro,
              700,
              16px,
              $v3-dark-primarytext
            );
            margin-right: 8px;
          }
        }
      }

      .bottom-description {
        margin-top: 24px;
        margin-left: 20px;

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, $v3-dark-primarytext);
          margin-bottom: 15px;

          img {
            margin-right: 17px;
          }
        }

        p {
          @include apply-font($sourcesanspro, 700, 13px, #91b3ba);

          img {
            margin-right: 17px;
          }
        }
        &:nth-child(1n) {
          h1 {
            color: rgba(26, 177, 199, 1) !important;
          }
        }
        &:nth-child(2n) {
          h1 {
            color: rgba(118, 224, 239, 1) !important;
          }
        }
        &:nth-child(3n) {
          h1 {
            color: rgba(39, 222, 191, 1) !important;
          }
        }
      }

      .bottom-description:last-child {
        margin-top: 20px;
      }
    }
  }

  .filter-data-tile:last-child {
    margin-right: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, $v3-dark-primarytext);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #000000;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      left: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: $v3-dark-primarytext;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: linear-gradient(
        152.47deg,
        rgba(255, 255, 255, 0.04) 0.74%,
        rgba(255, 255, 255, 0) 97.97%
      );
      filter: drop-shadow(0px 11px 81px rgba(0, 0, 0, 0.26));
      border: 1px solid rgba(12, 46, 46, 1);
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($sourcesanspro, 800, 14px, #4a7780);
      }

      &.active.all {
        background: $v3-all;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid $v3-dark-primarytext;
        }

        h1 {
          color: $v3-dark-primarytext !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }

      .mark.onplanned {
        background: $v3-onplanned;
      }

      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .table-container {
    padding: 0px 10px 37px 0px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          @include apply-font($almarai, 700, 12px, $v3-dark-primarytext);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-dark-header-color;
        }

        td {
          @include apply-font($almarai, 400, 12px, $v3-dark-primarytext);
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font($sourcesanspro, 400, 12px, $v3-dark-primarytext);
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff !important;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onpending;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, #fff);

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-right: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
        border: 1px solid #fff;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-left: 20px;
        margin-right: 5px;
      }

      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-dark-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 18px, $v3-dark-primarytext);
    }
  }

  .sector-status {
    @include apply-font($almarai, 400, 18px, $v3-dark-primarytext);
    margin-top: 10px;
  }
}
body.theme-medium.en {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-left: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }

    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      right: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-right: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      }
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }

        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      @include applyGradientBorderMediumV3;
      box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);

      .floating-number {
        position: absolute;
        top: 10px;
        right: 18px;
        width: 47px;
        height: 47px;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }

      .tilehead {
        background: $v3-medium-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($sourcesanspro, 400, 14px, $v3-medium-primarytext);
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .tilehead-icon {
          margin-right: 20px;
        }
      }

      h1 {
        @include apply-font($sourcesanspro, 700, 16px, $v3-medium-primarytext);
      }
      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font(
              $sourcesanspro,
              400,
              21px,
              $v3-medium-primarytext
            );
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-medium-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorderMediumV3;
        box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
        border-radius: 13px;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: $v3-medium-header-color;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font(
            $sourcesanspro,
            400,
            21px,
            $v3-medium-primarytext
          );
        }
      }
      .budget-tile:last-child {
        margin-right: 0px;
      }
    }
  }
  .filter-based-data > h1 {
    @include apply-font($sourcesanspro, 300, 20px, $v3-medium-primarytext);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 33px;
  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-right: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorderMediumV3;
    box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
    cursor: pointer;

    a {
      text-decoration: none !important;
      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid #dee6e6;
        padding-bottom: 26px;

        .task-check {
          display: flex;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }

        h1 {
          @include apply-font(
            $sourcesanspro,
            400,
            14px,
            $v3-medium-primarytext
          );
          text-align: center;
        }

        h2 span {
          @include apply-font($sourcesanspro, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, rgba(28, 69, 103, 1));
          }
          .progress {
            background: #b4d1d7 !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;
            .progress-bar {
              background: #ffffff;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, rgba(13, 44, 68, 1));
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              background: $v3-expectedlate !important;
            }
            .late {
              background: $v3-late !important;
            }

            .completed {
              background: $v3-completed !important;
            }
          }
        }
      }

      .round-chart {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        h1 {
          @include apply-font($sourcesanspro, 700, 10px, #527a7a);
        }

        #chart {
          img {
            margin-top: -20px;
            margin-left: 30px;
          }
        }

        h2 {
          margin-bottom: 15px;
          @include apply-font($sourcesanspro, 700, 10px, #527a7a);

          b {
            @include apply-font(
              $sourcesanspro,
              700,
              16px,
              $v3-medium-primarytext
            );
            margin-right: 8px;
          }
        }
      }

      .bottom-description {
        margin-top: 24px;
        margin-left: 20px;

        h1 {
          @include apply-font(
            $sourcesanspro,
            400,
            14px,
            $v3-medium-primarytext
          );
          margin-bottom: 15px;

          img {
            margin-right: 17px;
          }
        }

        p {
          @include apply-font($sourcesanspro, 700, 13px, #527a7a);

          img {
            margin-right: 17px;
          }
        }
        &:nth-child(1n) {
          h1 {
            color: rgba(16, 60, 100, 1) !important;
          }
        }
        &:nth-child(2n) {
          h1 {
            color: rgba(16, 119, 121, 1) !important;
          }
        }
        &:nth-child(3n) {
          h1 {
            color: rgba(28, 94, 18, 1) !important;
          }
        }
      }

      .bottom-description:last-child {
        margin-top: 20px;
      }
    }
  }

  .filter-data-tile:last-child {
    margin-right: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #fff);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #e7e7e7;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      left: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: #fff;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: #ffffff;
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($sourcesanspro, 800, 14px, #4a7780);
      }

      &.active.all {
        background: $v3-all;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }

      .mark.onplanned {
        background: $v3-onplanned;
      }

      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .table-container {
    padding: 0px 10px 37px 0px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          @include apply-font($almarai, 700, 12px, #fff);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-medium-table-stripes;
        }

        &:nth-child(even) {
          background: $v3-medium-table-stripes-even;
        }

        td {
          @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font($almarai, 400, 12px, $v3-medium-primarytext);
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff !important;
          white-space: nowrap;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onplanned;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, $v3-medium-primarytext);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, $v3-medium-primarytext);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-right: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
        border: 1px solid $v3-medium-primarytext;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-left: 20px;
        margin-right: 5px;
      }

      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-medium-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 18px, $v3-medium-primarytext);
    }
  }
  .sector-status {
    @include apply-font($almarai, 400, 18px, $v3-medium-primarytext);
    margin-top: 10px;
  }
}
body.theme-light.en {
  .tab-toggles {
    display: flex;
    margin-top: 40px;
    position: relative;
    border: 0px;
    padding-left: 0;
    &.onplanned {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-onplanned;
    }
    &.completed {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-completed;
    }
    &.expectedlate {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-expectedlate;
    }
    &.late {
      border-bottom: 7px;
      border-style: solid;
      border-color: $v3-late;
    }

    .homeicon {
      width: 47px;
      height: 47px;
      border-radius: 47px;
      background: #103c64;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 13px;
      right: 0;
      cursor: pointer;
    }
    .toggle {
      width: 250px;
      height: 75px;
      border-radius: 9px;
      margin-right: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row-reverse;
      vertical-align: middle;
      cursor: pointer;

      .count {
        @include apply-font($sourcesanspro, 700, 40px, #fff);
      }
      .title {
        @include apply-font($almarai, 700, 14px, #fff);
      } 
    }
    .toggle.active {
      height: 107px;
      border-radius: 9px 9px 0px 0px;
      align-items: flex-start;
      padding-top: 0px;
      .title {
        margin-top: 20px;
      }
      .count {
        margin-top: 13px;
      }
      img {
        margin-top: 18px;
      }
    }
    .toggle.onplanned {
      background: $v3-onplanned;
    }
    .toggle.completed {
      background: $v3-completed;
    }
    .toggle.expectedlate {
      background: $v3-expectedlate;
    }
    .toggle.late {
      background: $v3-late;
    }
  }
  .tiles-section {
    display: inline-flex;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-dark-dashed-seperator;

    .sector-tile-proto {
      width: 301px;
      height: 364px;
      padding: 25px 15px;
      border-radius: 13px;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
      margin-bottom: 50px;
      margin-left: 53px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-left: 0px;
      }

      .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 15px;

        h1 {
          @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
          margin-top: 23px;
        }
        h2 {
          @include apply-font($almarai, 700, 17px, #000);
          margin-top: 40px;
        }
        .mark-container {
          display: inline-flex;
          margin-top: 20px;
          margin-bottom: 35px;
        }
        .mark {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 41px;
          height: 41px;
          border-radius: 5px;
          margin-left: 10px;
          margin-right: 10px;
          @include apply-font($sourcesanspro, 700, 18px, #fff);
        }
        .mark.late {
          background: $v3-late;
        }
        .mark.expectedlate {
          background: $v3-expectedlate;
        }
        .mark.onplanned {
          background: $v3-onplanned;
        }
        .mark.completed {
          background: $v3-completed;
        }

        .mark.archived {
          background: $v3-archived;
        }
      }
    }
  }
  .chart-container {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;
    position: relative;

    .chart-tile {
      width: 417px;
      height: 337px;
      border-radius: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      @include applyGradientBorder;
      box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);

      .floating-number {
        position: absolute;
        top: 10px;
        right: 18px;
        width: 47px;
        height: 47px;
        background: #fff;
        border-radius: 47px;
        border: 2px solid #00babe;
        margin: 0;
        @include apply-font($sourcesanspro, 700, 23px, #00babe);
        text-align: center;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        filter: drop-shadow(0px 4px 16px rgba(0, 250, 255, 0.62));
      }

      .tilehead {
        background: $v3-light-header-color;
        width: 417px;
        height: 67px;
        @include apply-font($sourcesanspro, 400, 14px, $v3-light-primarytext);
        border: 1px solid #e3e3e3;
        border-radius: 12px 12px 0px 0px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .tilehead-icon {
          margin-right: 20px;
        }
      }

      h1 {
        @include apply-font($sourcesanspro, 700, 16px, #4a7780);
      }
      .chart-desc-container {
        display: flex;
        justify-content: space-between;
        width: 300px;
        margin-top: 10px;
        .chart-desc {
          h5 {
            @include apply-font($almarai, 700, 13px, #91b3ba);
          }
          h6 {
            @include apply-font(
              $sourcesanspro,
              400,
              21px,
              $v3-medium-primarytext
            );
          }
        }
      }
    }
  }
  .budget-records {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 25px;
    padding-bottom: 32px;
    border-bottom: 1px dashed $v3-light-dashed-seperator;

    h1 {
      @include apply-font($almarai, 300, 20px, #fff);
      text-align: center;
      margin-bottom: 63px;
    }
    .budget-tile-container {
      display: inline-flex;
      .budget-tile {
        width: 208px;
        height: 210px;
        @include applyGradientBorder;
        box-shadow: 17px 27px 44px rgba(0, 0, 0, 0.04);
        border-radius: 13px;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        .icon {
          width: 82px;
          height: 82px;
          border-radius: 82px;
          background: $v3-medium-header-color;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        h3 {
          @include apply-font($almarai, 700, 13px, #91b3ba);
        }
        h4 {
          @include apply-font(
            $sourcesanspro,
            400,
            21px,
            $v3-medium-primarytext
          );
        }
      }
      .budget-tile:last-child {
        margin-right: 0px;
      }
    }
  }
  #databased-row {
    padding-bottom: 66px;
  }

  .filter-based-data > h1 {
    @include apply-font($sourcesanspro, 300, 20px, $v3-dark-primarytext);
  }

  .filter-based-data {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 63px 33px;
  }

  .filter-data-tile {
    width: 417px;
    padding: 19px 5px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    margin-right: 37px;
    margin-bottom: 40px;
    border-radius: 13px;
    @include applyGradientBorder;
    box-shadow: 17px 27px 46px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    a {
      text-decoration: none !important;
      .tilehead {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-bottom: 2px solid #dee6e6;
        padding-bottom: 26px;

        .task-check {
          display: flex;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
        }
        h1 {
          @include apply-font($sourcesanspro, 400, 14px, #103c64);
          text-align: center;
        }

        h2 span {
          @include apply-font($sourcesanspro, 700, 12px, #fff);
          padding: 5px 36px;
          border-radius: 4px;
        }

        h2 span.late {
          background: $v3-late;
        }

        h2 span.expectedlate {
          background: $v3-expectedlate;
        }

        h2 span.completed {
          background: $v3-completed;
        }

        h2 span.onplanned {
          background: $v3-onplanned;
        }

        h2 span.archived {
          background: $v3-archived;
        }
        .project-progress-date {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 100%;
          padding: 10px 20px;
          .pinfo {
            display: flex;
            justify-content: space-between;
          }
          span {
            @include apply-font($almarai, 700, 13px, rgba(28, 69, 103, 1));
          }
          .progress {
            background: #ebebeb !important;
            border-radius: 12px !important;
            padding: 3px;
            height: 22px;
            position: relative;
            .progress-bar {
              background: #103c64;
              border-radius: 12px !important;
              @include apply-font($almarai, 700, 14px, #ffffff);
            }
            .diamond {
              width: 12px;
              height: 12px;
              background: $v3-onplanned;
              position: absolute;
              transform: rotate(45deg);
              top: 5px;
            }
            .onplanned {
              background-color: $v3-onplanned;
            }
            .expectedlate {
              background: $v3-expectedlate !important;
            }
            .late {
              background: $v3-late !important;
            }

            .completed {
              background: $v3-completed !important;
            }
          }
        }
      }

      .round-chart {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        h1 {
          @include apply-font($sourcesanspro, 700, 10px, #103c64);
        }

        #chart {
          img {
            margin-top: -20px;
            margin-left: 30px;
          }
        }

        h2 {
          margin-bottom: 15px;
          @include apply-font($sourcesanspro, 700, 10px, #90b2b9);

          b {
            @include apply-font($sourcesanspro, 700, 16px, #103c64);
            margin-right: 8px;
          }
        }
      }

      .bottom-description {
        margin-top: 24px;
        margin-left: 20px;

        h1 {
          @include apply-font($sourcesanspro, 400, 14px, #103c64);
          margin-bottom: 15px;

          img {
            margin-right: 17px;
          }
        }

        p {
          @include apply-font($sourcesanspro, 700, 13px, #90b2b9);

          img {
            margin-right: 17px;
          }
        }
        &:nth-child(1n) {
          h1 {
            color: rgba(19, 156, 176, 1) !important;
          }
        }
        &:nth-child(2n) {
          h1 {
            color: rgba(72, 193, 210, 1) !important;
          }
        }
        &:nth-child(3n) {
          h1 {
            color: rgba(27, 183, 156, 1) !important;
          }
        }
      }

      .bottom-description:last-child {
        margin-top: 20px;
      }
    }
  }

  .filter-data-tile:last-child {
    margin-right: 0;
  }

  .tile-table {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 60px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #103c64);
      margin-right: 20px;
      margin-left: 20px;
    }

    .custom-filter {
      width: 77px;
      height: 35.12px;
      border-radius: 17.5px;
      background: #e7e7e7;
      display: flex;
      justify-content: space-between;
      padding-left: 7px;
      padding-right: 7px;
      align-items: center;
      position: absolute;
      left: 0;

      .togg {
        width: 24.32px;
        height: 24.32px;
        border-radius: 24.32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
        cursor: pointer;
      }

      .togg.active {
        background: #fff;
      }
    }
  }

  .tab-data {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .tabs {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;
      height: 62px;
      background: $v3-light-header-color;
      border-radius: 50px;
      position: relative;
      margin-left: 9px;
      margin-bottom: 66px;
      cursor: pointer;
      /* Rectangle 204 */

      h1 {
        @include apply-font($sourcesanspro, 800, 14px, #103c64);
      }

      &.active.all {
        background: $v3-all;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.late {
        background: $v3-late;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.completed {
        background: $v3-completed;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.onplanned {
        background: $v3-onplanned;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.expectedlate {
        background: $v3-expectedlate;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      &.active.archived {
        background: $v3-archived;

        .mark {
          background: transparent;
          border: 1px solid #fff;
        }

        h1 {
          color: #fff !important;
        }
      }

      .mark {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 31px;
        height: 31px;
        border-radius: 31px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include apply-font($sourcesanspro, 700, 13px, #fff);
      }

      .mark.all {
        background: $v3-all;
      }

      .mark.late {
        background: $v3-late;
      }

      .mark.completed {
        background: $v3-completed;
      }

      .mark.expectedlate {
        background: $v3-expectedlate;
      }

      .mark.onplanned {
        background: $v3-onplanned;
      }

      .mark.archived {
        background: $v3-archived;
      }
    }
  }

  .markline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }

  .table-container {
    padding: 0px 10px 0px 10px;
    margin-top: 0px;

    table {
      width: 100%;
      border-collapse: separate !important;
      border-spacing: 0;

      thead > tr {
        background: #1978b2;
        height: 45px;

        th {
          @include apply-font($almarai, 700, 12px, #fff);
          text-align: center;
        }

        th.date {
          width: 140px;
        }

        th.status {
          width: 150px;
        }
      }

      tbody > tr {
        height: 63px;

        &:nth-child(odd) {
          background: $v3-light-table-stripes;
        }

        td {
          @include apply-font($almarai, 400, 12px, #103c64);
          padding: 0px 10px;
        }

        td:last-child {
          border-left: 0px;
        }

        td.eng {
          @include apply-font($sourcesanspro, 400, 12px, #103c64);
        }

        td.center {
          text-align: center;
        }

        td span {
          border-radius: 4px;
          padding: 4px 13px;
          color: #fff !important;
        }

        td.late {
          span {
            background: $v3-late;
          }
        }

        td.expectedlate {
          span {
            background: $v3-expectedlate;
          }
        }

        td.onplanned {
          span {
            background: $v3-onplanned;
          }
        }

        td.completed {
          span {
            background: $v3-completed;
          }
        }

        @keyframes buzzerLightAr {
          from {
            background-color: $verylate;
          }

          to {
            background-color: $verylateBlur;
          }
        }
      }
    }
  }
  .filter-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 45px;
    margin-bottom: 40px;
    margin-top: 20px;
    position: relative;
    flex-wrap: wrap;
  }
  .dropdown-filter {
    width: 200px;
    height: 50px;
    border: 1px solid #2a3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;

    span {
      @include apply-font($almarai, 700, 15px, $v3-light-primarytext);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 20px;
      color: #fff;
    }
  }
  .filter-dropdown {
    width: 250px;
    height: auto;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @include apply-font($almarai, 400, 14px, $v3-light-primarytext);

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, $v3-light-primarytext);
        }
      }
      li:hover {
        background: rgba(0, 0, 0, 0.34);
      }
    }
  }
  .panel-wrapper {
    display: flex;
    height: auto;
    flex-wrap: wrap;

    .current-filters {
      margin-right: 10px;
      margin-bottom: 30px;
      .active-filter {
        @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
        border: 1px solid $v3-light-primarytext;
        border-radius: 17.56px;
        padding: 8px 20px;
        margin-left: 20px;
        margin-right: 5px;
      }

      img {
        cursor: pointer;
      }
    }
  }
  .cf-project-count {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    span {
      @include apply-font($almarai, 700, 14px, $v3-light-primarytext);
    }
    h1 {
      @include apply-font($almarai, 700, 18px, $v3-light-primarytext);
    }
  }
  .sector-status {
    @include apply-font($almarai, 400, 18px, $v3-light-primarytext);
    margin-top: 10px;
  }
}
</style>
